export const DOMINIO_PRINCIPAL = process.env.REACT_APP_DOMINIO_PRINCIPAL;

// En el dominio principal la API se usa en el mismo origen; en los demás, la configurada.
const enPrincipal = DOMINIO_PRINCIPAL && window.location.origin === DOMINIO_PRINCIPAL;
export const BACKEND = enPrincipal ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;
export const URL_ROGE = DOMINIO_PRINCIPAL || window.location.origin;
